import React, { useState } from 'react';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import api from '../../utils/axiosConfig';
import { useLayout } from '../PageLayout/LayoutContext';

function Header({ showSidebar = true }) {
  const navigate = useNavigate();
  const { toggleSidebar, sidebarCollapsed, isMobile } = useLayout();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const showBrand = !showSidebar || sidebarCollapsed;
  const showMenuToggle = showSidebar && (sidebarCollapsed || isMobile);

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('x-session-key');
      localStorage.removeItem('isLoggedIn');
      navigate('/login');
    }
  };

  const confirmLogout = async () => {
    setShowLogoutConfirm(false);
    await handleLogout();
  };

  return (
    <>
      <header className={`header${!showSidebar || sidebarCollapsed ? ' header--collapsed-sidebar' : ''}${isMobile ? ' header--mobile' : ''}`}>
        <div className="header-left">
          {showMenuToggle && (
            <button
              type="button"
              className="header-menu-toggle"
              onClick={toggleSidebar}
              aria-label={sidebarCollapsed ? 'Show sidebar' : 'Hide sidebar'}
            >
              <FaBars aria-hidden="true" />
            </button>
          )}

          {showBrand && (
            <div className="header-brand">
              <img src="/assets/logo.png" alt="" className="header-brand-logo" />
              <div className="header-brand-text">
                <span className="header-brand-name">Shivam Buildcare</span>
                <span className="header-brand-tag">Business workspace</span>
              </div>
            </div>
          )}
        </div>

        <div className="nav-logout-container">
          <button
            type="button"
            onClick={() => setShowLogoutConfirm(true)}
            className="logout-button"
          >
            Logout
          </button>
        </div>
      </header>

      {showLogoutConfirm && (
        <div
          className="logout-modal-overlay"
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            className="logout-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-labelledby="logout-modal-title"
          >
            <h2 id="logout-modal-title">Logout</h2>
            <p>Are you sure you want to logout?</p>
            <div className="logout-modal-actions">
              <button
                type="button"
                className="logout-modal-cancel"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="logout-modal-confirm"
                onClick={confirmLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
